export const isNonNullable = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined;

type Truthy<T> = T extends 0 | '' | false | null | undefined ? never : T;
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
export const isTruthy = <T>(value: T): value is Truthy<T> => Boolean(value);
